<template>
    <div class="carousel-wrapper">

        <carousel :items-to-show="1" :autoplay="duration" v-bind="config">

            <slide v-for="(item, index) in items" :key="index" class="relative">
                <div
                    class="relative h-[100vh] item">

                    <div
                        class="bg absolute top-[0] left-[0] carousel-image h-full w-[100vw] block bg-cover backdrop-brightness-50
                        h-[500px] md:h-[600px] xl:h-[700px] 2xl:h-screen z-[0]"
                        :class="[(item.heading) ? 'darken' : '']"
                        :style="itemBGImage(item)">
                    </div>
                    <div
                        class="content flex flex-col overflow-hidden flex-center-all items-end content-end absolute top-[0px] right-[0px] hidden py-6 text-center text-white-rgb z-[1] p-8">
                        <h2 class="text-xl text-white-rgb text-[3.5rem]">
                            {{ item.heading }}
                        </h2>
                        <p class="text-white-rgb">
                            {{ item.subheading }}
                        </p>
                    </div>
                </div>

            </slide>

            <template #addons="{ slidesCount }">
                <Navigation v-if="slidesCount > 1"/>
                <pagination/>
            </template>
        </carousel>
    </div>
</template>

<script>
// If you are using PurgeCSS, make sure to whitelist the carousel CSS classes
import 'vue3-carousel/dist/carousel.css'
import {Carousel, Navigation, Pagination, Slide} from 'vue3-carousel'

export default {
    name: "CarouselHolder",
    props: {
        duration: {
            type: Number,
            default: 5000
        },
        items: {
            type: Array,
            default: () => []
        }
    },
    data: {
        currentItem: 0,
        screenWidth: 2000,
        config: {
            wrapAround: true,
            pauseAutoplayOnHover: true,
        }
    },
    computed: {
        responsiveImage: function () {
            var width = this.screenWidth;
            if (width < 540) {
                return "image540";
            }
            if (width < 768) {
                return "image768";
            }
            if (width < 992) {
                return "image992";
            }
            if (width < 1200) {
                return "image1200";
            }
            if (width < 1500) {
                return "image1500";
            }
            if (width < 2000) {
                return "image2000";
            }
            if (width < 2500) {
                return "image2500";
            }
            return "image2000";
        }
    },
    methods: {
        itemBGImage: function (item) {
            return 'background-image: url(' + item[this.responsiveImage] + ')';
        }
    },
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },
    mounted: function () {
        this.screenwidth = window.innerWidth;
        this.config.autoplay = this.duration;
        // set watcher to set this.width on resize window
        window.addEventListener('resize', () => {
            this.screenWidth = window.innerWidth;
        });
    }
}
</script>

<style >

    :root {
        --vc-nav-color: #fff;
        --vc-icn-width: 50px;
        --vc-icn-height: 50px;
    }

    .carousel-wrapper .item, .carousel-wrapper .bg, .carousel-wrapper .content {
        height: calc(100vh - 100px);
        width: 100vw;
    }

    .carousel-wrapper .item.bg {
        overflow: hidden;
    }

    .carousel-wrapper .content * {
        max-width: 800px;
    }

    .carousel-wrapper .bg {
        position: relative;
        background-color: #333;
        z-index: 0;
    }

    .carousel-wrapper .bg.darken:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 0;
    }

    .carousel-wrapper .content {
        position: relative;
        z-index: 1;
        color: #fff;
        display: flex;
        justify-content: center;
    }

    .carousel-wrapper .carousel__slide {
        padding-inline-start: 0;
    }
    .carousel-wrapper .carousel__viewport {
        position: relative;
        z-index: 1;
    }

    .carousel-wrapper .carousel__pagination {
        position: relative;
        z-index: 5;
        margin-top: -30px;
    }

    .carousel-wrapper .carousel__pagination-button::after{
        background-color: #fff;
        opacity: 0.5;
    }
    .carousel-wrapper .carousel__pagination-button--active::after {
        opacity: 1;
    }

    .carousel-wrapper .carousel__prev,
    .carousel-wrapper .carousel__next,
    .carousel-wrapper .carousel__icon {
        fill: #fff;
        z-index: 5;
    }

</style>
